import NewSound from '@/components/NewSound'
import NewMedia from '@/components/NewMedia'
import NewNote from '@/components/NewNote'
// import NewFile from '@/components/NewFile'

export default {
  name: 'AddNew',
  props: {
    draft: Object,
    type: String,
    back: {
      type: String,
      default: '/'
    }
  },
  render (h) {
    let type = this.$route.params.resource || this.type
    // select component to load
    const el = `new-${type}`
    return h(el, {
      props: { back: this.back, type: this.type, draft: this.draft },
      on: this.$listeners
    })
  },
  components: { NewSound, NewMedia, NewNote } // NewFile
}
